module.exports = __webpack_public_path__ + "img/w3_check_dark.daf1f08b.png";